import { SVGProps, Ref, forwardRef } from 'react';

export const ArrowDownRightOutlinedSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2 2h1.8v2c0 2.854.002 4.904.212 6.464.206 1.534.598 2.459 1.282 3.142.683.684 1.608 1.076 3.142 1.282 1.56.21 3.61.212 6.464.212h3.654l-3.827-3.827L16 10l6 6-6 6-1.273-1.273 3.827-3.827h-3.723c-2.77 0-4.94 0-6.635-.228-1.733-.233-3.101-.72-4.175-1.793-1.074-1.074-1.56-2.442-1.793-4.175C2 9.01 2 6.839 2 4.069z"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
ArrowDownRightOutlinedSize24Glyph.displayName = 'ArrowDownRightOutlinedSize24Glyph';
